// import React, { ReactNode, lazy } from "react"
import React, { lazy } from 'react'

// import Home from "@/views/home/home"
// import HotSheet from "@/views/hotSheet/hotSheet"
// import Djradio from "@/views/djradio/djradio"
// import SheetDetail from "@/views/sheetDetail/sheetDetail"
// import SongDetail from "@/views/songDetail/songDetail"
// import SingerDetail from "@/views/singerDetail/singerDetail"
// import SinameDetail from "@/views/sinameDetail/sinameDetail"
// import SearchDetail from "@/views/searchDetail/searchDetail"
// import VideoDetail from "@/views/videoDetail/videoDetail"
// import MySheet from "@/views/mySheet/mySheet"
// import MyCollect from "@/views/myCollect/myCollect"
// import Test from "@/views/test/test"

const Home = lazy(() => import('@/views/home/home'))
const HotSheet = lazy(() => import('@/views/hotSheet/hotSheet'))
const HotSinger = lazy(() => import('@/views/hotSinger/hotSinger'))
const Djradio = lazy(() => import('@/views/djradio/djradio'))
const SheetDetail = lazy(() => import('@/views/sheetDetail/sheetDetail'))
const SongDetail = lazy(() => import('@/views/songDetail/songDetail'))
const SingerDetail = lazy(() => import('@/views/singerDetail/singerDetail'))
const SinameDetail = lazy(() => import('@/views/sinameDetail/sinameDetail'))
const SearchDetail = lazy(() => import('@/views/searchDetail/searchDetail'))
const VideoDetail = lazy(() => import('@/views/videoDetail/videoDetail'))
const MySheet = lazy(() => import('@/views/mySheet/mySheet'))
const MyCollect = lazy(() => import('@/views/myCollect/myCollect'))
const Person = lazy(() => import('@/components/person/person'))
const Test = lazy(() => import('@/views/test/test'))
const ClassCom = lazy(() => import('@/views/classCom/classCom'))

const routes = [
  // {
  //   path: "/",
  //   // component: lazy(() => import("@/views/home/home")),
  //   redirect: { name: "home" }
  // },
  {
    path: '/home',
    name: 'home',
    component: <Home></Home>,
    meta: {
      title: '首页'
    }
  },
  {
    path: '/hotSheet',
    name: 'hotSheet',
    component: <HotSheet></HotSheet>,
    meta: {
      title: '精品歌单'
    }
  },
  {
    path: '/hotSinger',
    name: 'hotSinger',
    component: <HotSinger></HotSinger>,
    meta: {
      title: '热门歌手'
    }
  },
  {
    path: '/djradio',
    name: 'djradio',
    component: <Djradio></Djradio>,
    meta: {
      title: '电台'
    }
  },
  {
    path: '/songDetail',
    name: 'songDetail',
    component: <SongDetail></SongDetail>,
    meta: {
      title: '歌曲详情'
    }
  },
  {
    path: '/sheetDetail',
    name: 'sheetDetail',
    component: <SheetDetail></SheetDetail>,
    meta: {
      title: '歌单详情'
    }
  },
  {
    path: '/singerDetail',
    name: 'singerDetail',
    component: <SingerDetail></SingerDetail>,
    meta: {
      title: '歌手详情'
    }
  },
  {
    path: '/sinameDetail',
    name: 'sinameDetail',
    component: <SinameDetail></SinameDetail>,
    meta: {
      title: '专辑详情'
    }
  },
  {
    path: '/searchDetail',
    name: 'searchDetail',
    component: <SearchDetail></SearchDetail>,
    meta: {
      title: '搜索详情'
    }
  },
  {
    path: '/videoDetail',
    name: 'videoDetail',
    component: <VideoDetail></VideoDetail>,
    meta: {
      title: '视频详情'
    }
  },
  {
    path: '/mySheet',
    name: 'mySheet',
    component: <MySheet></MySheet>,
    meta: {
      title: '我的歌单'
    }
  },
  {
    path: '/myCollect',
    name: 'myCollect',
    component: <MyCollect></MyCollect>,
    meta: {
      title: '我的收藏'
    }
  },
  // {
  //   path: "/person",
  //   name: "person",
  //   component: <Person></Person>,
  //   meta: {
  //     title: "个人中心"
  //   }
  // },
  // {
  //   path: "/person",
  //   name: "person",
  //   component: <Person></Person>,
  //   meta: {
  //     title: "个人中心"
  //   }
  // },
  {
    path: '/test',
    name: 'test',
    component: <Test></Test>,
    meta: {
      title: '测试路由'
    }
  },
  {
    path: '/classCom',
    name: 'classCom',
    component: <ClassCom></ClassCom>,
    meta: {
      title: '类组件路由'
    }
  }
]
export default routes
